export class PreClaimHistoryDetails
{
    public InsurerName: string;
    public NatureofClaim: string;
    public AmountofClaim: string;
    public DateofClaim: string;

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/PreClaimHistoryDetails.ts